import React from "react";
import { difficultyMeta } from "../lib/gradient";

/**
 * DifficultyPill — rounded-full pill coloured by difficulty tier.
 * Renders nothing when `difficulty` is unknown so callers don't need to
 * conditionally mount it. Sizes: `sm` fits Discover cards, `md` for the
 * trail-page summary strip.
 */
export default function DifficultyPill({ difficulty, size = "sm", testId }) {
  const meta = difficultyMeta(difficulty);
  if (!meta) return null;
  const padding = size === "md" ? "px-3 py-1 text-sm" : "px-2 py-0.5 text-xs";
  return (
    <span
      data-testid={testId || `difficulty-pill-${difficulty}`}
      className={`inline-flex items-center rounded-full font-semibold ${padding}`}
      style={{ color: meta.color, background: meta.bg, borderWidth: 1, borderColor: meta.color }}
    >
      {meta.label}
    </span>
  );
}
